/* eslint-disable compat/compat */
import React from 'react'
import { string, arrayOf, shape } from 'prop-types'
import { motion } from 'framer-motion'
import { graphql } from 'gatsby'
import PageTitle from '@/components/PageTitle'
import withTheme from '@/utils/withTheme'
import Team from '@/components/Team'
import Image from '@/utils/Image'
import SEOMatic from '@/components/SEOMatic'
import * as T from '@/types'
import { fade } from '@/utils/transitions'

function HeroImage({ image }) {
	const { optimisedBanner, ...imageProps } = image

	return (
		<motion.div
			variants={fade}
			initial="initial"
			className="absolute top-0 left-0 object-cover w-full h-full"
		>
			<Image
				{...imageProps}
				image={optimisedBanner}
				style={{ height: '100%' }}
			/>
		</motion.div>
	)
}

HeroImage.propTypes = {
	image: T.craftImageBanner.isRequired,
}

function ContactPage({ data }) {
	const {
		craft: { entry, seo },
	} = data

	const { team, reps } = entry
	const [image] = entry.image

	return (
		<>
			<SEOMatic {...seo} />
			<div className="relative py-32">
				{image && <HeroImage image={image} />}
				<motion.div
					variants={fade}
					initial="initial"
					className="relative z-10 px-8 wrapper "
				>
					<PageTitle className="text-white text-shadow-sm">
						{entry.title}
					</PageTitle>
					<div className="font-semibold text-white text-shadow">
						<h6 className="uppercase">{entry.title}</h6>
						<address className="inline not-italic whitespace-pre-wrap">
							{entry.address}
						</address>
						<a className="ml-2" href={`tel:${entry.telephone}`}>
							{entry.telephone}
						</a>
					</div>
				</motion.div>
			</div>

			<motion.div variants={fade} initial="initial" className="pb-24 bg-team">
				{team && !!team.length && <Team title="The Team" team={team} />}
				{reps && !!reps.length && <Team title="Our Reps" team={reps} />}
			</motion.div>
		</>
	)
}

ContactPage.propTypes = {
	data: shape({
		craft: shape({
			entry: shape({
				title: string.isRequired,
				url: string.isRequired,
				uri: string.isRequired,
				address: string.isRequired,
				telephone: string.isRequired,
				image: arrayOf(T.craftImageBanner),
				team: arrayOf(T.personProps),
				reps: arrayOf(T.personProps),
				wechat: arrayOf(T.craftImage),
			}),

			seo: T.seomatic,
		}),
	}),
}

export const query = graphql`
	query ContactEntryQuery($siteStr: String, $uri: [String], $seo: String) {
		craft {
			entry(siteId: $siteStr, uri: $uri) {
				... on Craft_contact_contact_Entry {
					title
					siteId
					url
					uri
					address
					telephone
					image {
						...bannerImage
					}
					team {
						...peopleEntries
					}

					reps {
						...peopleEntries
					}
				}
			}

			seo: seomatic(uri: $seo, asArray: true) {
				...seoQuery
			}
		}
	}
`

export default withTheme(ContactPage, 'white')
